import {
  formatIsoDate,
  formatIsoDateAtEndOfDay,
  normalizeDateRange,
  NullableDateInput,
  relativeStartByToken,
} from "./date-range-helpers";

export type MantineDateValue = NullableDateInput;
export type MantineDateRangeValue = [MantineDateValue, MantineDateValue];

export interface MantineDateRangeIsoBounds {
  start_timestamp: string | null;
  end_timestamp: string | null;
}

export interface MantineDateFilterParams {
  created_at_gteq?: string;
  created_at_lteq?: string;
}

export const normalizeMantineRangeForPicker = (
  range: MantineDateRangeValue | null | undefined,
): [Date | null, Date | null] => {
  const normalized = normalizeDateRange(range);
  return [normalized.start, normalized.end];
};

export const resolveMantineRangeIsoBounds = (
  range: MantineDateRangeValue | null | undefined,
): MantineDateRangeIsoBounds => {
  const normalized = normalizeDateRange(range);

  return {
    start_timestamp: formatIsoDate(normalized.start),
    end_timestamp: formatIsoDateAtEndOfDay(normalized.end),
  };
};

export const buildMantineDateFilterParams = (
  preset: string,
  range: MantineDateRangeValue | null | undefined,
  options?: { referenceDate?: Date },
): MantineDateFilterParams => {
  const filters: MantineDateFilterParams = {};

  if (preset === "custom") {
    const { start_timestamp, end_timestamp } = resolveMantineRangeIsoBounds(range);

    if (start_timestamp) {
      filters.created_at_gteq = start_timestamp;
    }
    if (end_timestamp) {
      filters.created_at_lteq = end_timestamp;
    }

    return filters;
  }

  if (!preset || preset === "all") {
    return filters;
  }

  const referenceDate = options?.referenceDate ?? new Date();
  const presetStart = relativeStartByToken(preset, referenceDate);
  const startIso = formatIsoDate(presetStart);

  if (startIso) {
    filters.created_at_gteq = startIso;
  }

  return filters;
};
